// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yIcnz{background:radial-gradient(circle at bottom right, rgba(93, 19, 179, 0.25) 0, rgba(78, 69, 234, 0.08) 47.4%, transparent),radial-gradient(circle at bottom left, rgba(93, 19, 179, 0.25) 0, rgba(78, 69, 234, 0.08) 47.4%, transparent),linear-gradient(242deg, #eaf3ff 100%, transparent);height:100%;position:relative;display:flex;flex-direction:column;align-items:center;gap:16px;justify-content:space-between}.yIcnz.rvw7l{justify-content:flex-start;gap:0}.Y1Geq{position:fixed;min-width:100%;min-height:100%;object-fit:cover;z-index:0}._3mzW{z-index:1}.Fm97x{height:15%;flex-shrink:0}.jqYVS{width:134px;height:39px;position:absolute;left:40px;top:40px}@media(max-width: 560px){.jqYVS{width:91px;height:26px;left:24px;top:24px}}.XMPZK{font-family:"Lufga-SemiBold";font-weight:600;font-size:68px;line-height:64px;padding-top:min(10vh,128px);color:#282863;z-index:1000;text-align:center}@media(max-width: 560px){.XMPZK{font-size:var(--font-size-h5, 20px);line-height:var(--line-height-h5, 32px);padding-top:80px}}.zRGPl{font-family:"Lufga-Regular";font-weight:400;font-size:var(--font-size-h4, 24px);line-height:var(--line-height-h4, 34px);color:#696992;z-index:1000;text-align:center}@media(max-width: 560px){.zRGPl{display:none}}.ZF5lY{padding:20px}.ZF5lY.rvw7l{margin-top:auto;margin-bottom:auto}@media(max-width: 560px){.ZF5lY{padding:4px}}.pVVLz{width:546px;padding:20px 40px 28px 40px;border-radius:8px;box-shadow:0 30px 60px 0 rgba(119,116,157,.2);background:#fff;position:relative;z-index:1000}.pVVLz.uws08{width:944px}@media(max-width: 560px){.pVVLz.uws08{width:328px;padding:24px}}.pVVLz.rvw7l{width:480px;padding:24px}@media(max-width: 560px){.pVVLz.rvw7l{width:328px;padding:24px;margin-top:0}}@media(max-width: 560px){.pVVLz{width:328px;padding:24px}}.ay9BU{position:relative;bottom:6px}.yIcnz.rvw7l .ay9BU{margin-top:auto}.ay9BU .KAmAA{font-family:"Lufga-Regular";font-weight:400;font-size:var(--font-size-p2, 12px);line-height:var(--line-height-p2, 16px);letter-spacing:.02em;color:#282863;position:relative;margin-left:22px;display:inline-block;white-space:nowrap}.ay9BU .KAmAA:not(:first-child):before{position:absolute;content:"";left:-12px;border-radius:12px;background-color:#282863;width:4px;height:4px;top:calc(50% - 2px)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple100": `#dad0fe`,
	"purple300": `#c3b3fc`,
	"purple400": `#b4a1fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"sh10": `0px 4px 12px rgba(40,40,99,.06)`,
	"sh20": `0px 4px 16px rgba(40,40,99,.08)`,
	"sh40": `0px 4px 24px rgba(40,40,99,.12)`,
	"sh60": `0px 4px 14px rgba(40,40,99,.24)`,
	"fontFamilyLight": `"Lufga-Regular"`,
	"fontFamilyNormal": `"Lufga-Medium"`,
	"fontFamilyBold": `"Lufga-SemiBold"`,
	"fontSizeH1": `var(--font-size-h1, 40px)`,
	"fontSizeH2": `var(--font-size-h2, 36px)`,
	"fontSizeH3": `var(--font-size-h3, 28px)`,
	"fontSizeH4": `var(--font-size-h4, 24px)`,
	"fontSizeH5": `var(--font-size-h5, 20px)`,
	"fontSizeH6": `var(--font-size-h6, 18px)`,
	"fontSizeP1": `var(--font-size-p1, 14px)`,
	"fontSizeP2": `var(--font-size-p2, 12px)`,
	"fontSizeP3": `var(--font-size-p3, 10px)`,
	"lineHeightH1": `var(--line-height-h1, 56px)`,
	"lineHeightH2": `var(--line-height-h2, 52px)`,
	"lineHeightH3": `var(--line-height-h3, 36px)`,
	"lineHeightH4": `var(--line-height-h4, 34px)`,
	"lineHeightH5": `var(--line-height-h5, 32px)`,
	"lineHeightH6": `var(--line-height-h6, 30px)`,
	"lineHeightP1": `var(--line-height-p1, 22px)`,
	"lineHeightP2": `var(--line-height-p2, 16px)`,
	"lineHeightP3": `var(--line-height-p3, 14px)`,
	"mobileMaxWidth": `560px`,
	"tabletMinWidth": `561px`,
	"tabletMaxWidth": `1024px`,
	"desktopMinWidth": `1025px`,
	"smallScreenMaxWidth": `1400px`,
	"largeScreenMinWidth": `1401px`,
	"unauthorizedPageContainer": `yIcnz`,
	"otpLayout": `rvw7l`,
	"video": `Y1Geq`,
	"header": `_3mzW`,
	"headerSpacer": `Fm97x`,
	"logo": `jqYVS`,
	"title": `XMPZK`,
	"subTitle": `zRGPl`,
	"formWrapper": `ZF5lY`,
	"formCard": `pVVLz`,
	"wide": `uws08`,
	"footer": `ay9BU`,
	"link": `KAmAA`
};
export default ___CSS_LOADER_EXPORT___;
